export const UPDATE_AS_READ_PROCESS_STATEMENT_SUCCESS = 'UPDATE_AS_READ_PROCESS_STATEMENT_SUCCESS';

export const updateAsReadProcessStatementSuccess = processStatement => ({
    type: UPDATE_AS_READ_PROCESS_STATEMENT_SUCCESS,
    payload: { processStatement },
});
